/////////////Running Code:::::::::::::::::::::::::

import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast'
import { useDispatch, useSelector } from 'react-redux';

import classes from './Login.module.scss';
import InputField from './components/InputField/InputField';
import Visibile from './../../assets/icons/Hide.svg';
import RightArrow from './../../assets/icons/arrow.svg';
import { loginAuth, getLocation, fetchLocation } from './../../API/API';

const Login = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [userID, setUserID] = useState("");
  const [password, setPassword] = useState("");

  //env Error handling
  const EMPTY_CREDENTIALS = useRef(null);
  const INVALID_CREDENTIALS = useRef(null);
  const PROBLEM_FETCHING_LOCATION = useRef(null);
  const ERROR_SITE_LOCATIONS = useRef(null);
  const LOGIN_API_ERROR = useRef(null);
  const EMPID_NULL = useRef(null);

  //env Success Handling
  const LOGIN_SUCCESSFUL = useRef(null);
  const navigate = useNavigate();


  // For Handling Visibilty of Password 
  const changeVisibilty = () => {
    isVisible ? setIsVisible(false) : setIsVisible(true);
  }
  
  useEffect(() => {
    if (window.env) {
      
      //Errors
      EMPTY_CREDENTIALS.current = window.env.ERROR.EMPTY_CREDENTIALS
      INVALID_CREDENTIALS.current = window.env.ERROR.INVALID_CREDENTIALS
      PROBLEM_FETCHING_LOCATION.current = window.env.ERROR.PROBLEM_FETCHING_LOCATION
      ERROR_SITE_LOCATIONS.current = window.env.ERROR.ERROR_SITE_LOCATIONS
      LOGIN_API_ERROR.current = window.env.ERROR.LOGIN_API_ERROR
      EMPID_NULL.current = window.env.ERROR.EMPID_NULL
      //Success
      LOGIN_SUCCESSFUL.current = window.env.SUCCESS.LOGIN_SUCCESSFUL
    } else {
      toast.error("Problem in getting ENV File");
    }

    if (localStorage.getItem('data') !== null) {
      navigate('/dashboard/home');
    }

  }, [])

  const handleLogin = async (event) => {
    event.preventDefault();
    if (userID.trim().length === 0 || password.trim().length === 0) {
      // alert('Invalid User ID or Password');
      toast(EMPTY_CREDENTIALS.current, {
        icon: '❗',
        duration:4500
      });
      return false;
    }

    try {
      const response = await loginAuth(userID, password);

      if (response.status === 200) {
        if (response.data.error === "SIGNUPFAIL2") {
          toast(INVALID_CREDENTIALS.current, {
            icon: "❗",
          });
          return;
        }
        const token = response.data.token;
        const empID = response.data.empid;
        const modules = response.data.modules;
        const photo = response.data.photo



        localStorage.setItem("data", JSON.stringify(response.data));
        localStorage.setItem("userID", userID.toUpperCase());
        localStorage.setItem("modules", modules);



        let fetchedModule = JSON.parse(modules)
        
        if(empID === null || empID.trim().length === 0){
          toast(EMPID_NULL.current, {
            icon: "❗",
            duration: 4500,
          });
          return;
        }
        

        if (fetchedModule.length === 1 && fetchedModule.includes("CANTEEN")) {
          navigate('/dashboard/home');
          toast.success(LOGIN_SUCCESSFUL.current, {
            duration: 4000
          })
          return;
        }
        if (fetchedModule.includes("ATTENDANCE") && (photo.toString().length < 100 || photo == null)) {
          toast.success(LOGIN_SUCCESSFUL.current, {
            duration: 4000
          })
          console.log(LOGIN_SUCCESSFUL.current)
          navigate('/onboarding/1')
        } else {
          toast.success(LOGIN_SUCCESSFUL.current, {
            duration: 4000
          })
          navigate('/dashboard/home');
        }

        //Fetching All the Site Locations
        try {
          const response = await getLocation(userID, empID, token);
          localStorage.setItem("location", JSON.stringify(response.data));

          //Fetching Current Office Location
          if (response) {
            fetchLocation()
              .then((response2) => {
                if (response2) {
                  localStorage.setItem("fetchedLoc", JSON.stringify(response2));
                } else {
                  toast(PROBLEM_FETCHING_LOCATION.current, {
                    icon: "❗",
                    duration: 4500,
                  });
                }
              })
              .catch((error) => toast(error.message, {
                icon: "❗",
                duration: 4500,
              }));
          }
        } catch (error) {
          
          toast(ERROR_SITE_LOCATIONS.current, {
            icon: "❗",
          });
        }
      }
    } catch (error) {
      localStorage.clear()
      toast(LOGIN_API_ERROR.current, {
        icon: "❗",
        duration: 4500,
      });
    }

  }

  return (
    <section className={classes.container}>
      <div className={classes.LoginDiv}>
        <div className={classes.ImageDiv}>
          <img src={window.env.LOGO} alt="" width={"100"} />
          <div style={{ display: "flex", gap: "0px", flexDirection: "column", justifyContent: "center" }}>
            <h1>Login</h1>
            <p>Please login to continue</p>
          </div>
        </div>
        <InputField type='text' placeholder="Username" name="Username" onChange={(event) => { setUserID(event.target.value) }} value={userID.toUpperCase()} />
        <InputField type={isVisible ? 'text' : 'password'} placeholder="Password" name="Password" style={{ position: 'relative' }} onChange={(event) => { setPassword(event.target.value) }} value={password}>
          <img src={Visibile} alt="hidden Eye" style={{ position: 'absolute', padding: '20px', right: '0' }} onClick={changeVisibilty} />
        </InputField>
        <p onClick={() => { window.location.href = window.env.PWDRST_URL; }}>Forgot Your Password ?</p>
        <p onClick={() => { window.location.href = window.env.CHECK_URL; }}>Trouble Marking Attendnace ?</p>
        <button onClick={handleLogin}>
          Login
          <img src={RightArrow} alt="" />
        </button>


      </div>

    </section>
  )
}

export default Login

/////////////////////////////////////////////////////////////////////////////////
////////////////Testing Code:::::::::::::::::::::::
////////////////////////////////////////////////////////////////////////////////
// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import toast from "react-hot-toast";
// import { useDispatch, useSelector } from "react-redux";

// import classes from "./Login.module.scss";
// import InputField from "./components/InputField/InputField";
// import Visibile from "./../../assets/icons/Hide.svg";
// import RightArrow from "./../../assets/icons/arrow.svg";
// import { loginAuth, getLocation, fetchLocation } from "./../../API/API";

// // Utility to remove fetchedLoc from localStorage
// const removeFetchedLoc = () => {
//   localStorage.removeItem("fetchedLoc");
// };

// const Login = () => {
//   const [isVisible, setIsVisible] = useState(false);
//   const [userID, setUserID] = useState("");
//   const [password, setPassword] = useState("");

//   // Refs for error and success handling
//   const EMPTY_CREDENTIALS = useRef(null);
//   const INVALID_CREDENTIALS = useRef(null);
//   const PROBLEM_FETCHING_LOCATION = useRef(null);
//   const ERROR_SITE_LOCATIONS = useRef(null);
//   const LOGIN_API_ERROR = useRef(null);
//   const EMPID_NULL = useRef(null);
//   const LOGIN_SUCCESSFUL = useRef(null);

//   const navigate = useNavigate();

//   // Toggle password visibility
//   const changeVisibilty = () => {
//     setIsVisible((prevState) => !prevState);
//   };

//   useEffect(() => {
//     // Load environment variables
//     if (window.env) {
//       // Errors
//       EMPTY_CREDENTIALS.current = window.env.ERROR.EMPTY_CREDENTIALS;
//       INVALID_CREDENTIALS.current = window.env.ERROR.INVALID_CREDENTIALS;
//       PROBLEM_FETCHING_LOCATION.current = window.env.ERROR.PROBLEM_FETCHING_LOCATION;
//       ERROR_SITE_LOCATIONS.current = window.env.ERROR.ERROR_SITE_LOCATIONS;
//       LOGIN_API_ERROR.current = window.env.ERROR.LOGIN_API_ERROR;
//       EMPID_NULL.current = window.env.ERROR.EMPID_NULL;
//       // Success
//       LOGIN_SUCCESSFUL.current = window.env.SUCCESS.LOGIN_SUCCESSFUL;
//     } else {
//       toast.error("Problem in getting ENV File");
//     }

//     // Redirect to dashboard if already logged in
//     if (localStorage.getItem("data") !== null) {
//       navigate("/dashboard/home");
//     }

//     // Ensure fetchedLoc is removed on component mount
//     removeFetchedLoc();
//   }, []);

//   const handleLogin = async (event) => {
//     event.preventDefault();
//     if (userID.trim().length === 0 || password.trim().length === 0) {
//       toast(EMPTY_CREDENTIALS.current, {
//         icon: "❗",
//         duration: 4500,
//       });
//       return;
//     }

//     try {
//       const response = await loginAuth(userID, password);

//       if (response.status === 200) {
//         if (response.data.error === "SIGNUPFAIL2") {
//           toast(INVALID_CREDENTIALS.current, {
//             icon: "❗",
//           });
//           return;
//         }

//         const { token, empid: empID, modules, photo } = response.data;

//         // Save login data
//         localStorage.setItem("data", JSON.stringify(response.data));
//         localStorage.setItem("userID", userID.toUpperCase());
//         localStorage.setItem("modules", modules);

//         const fetchedModule = JSON.parse(modules);

//         // Check for invalid empID
//         if (!empID || empID.trim().length === 0) {
//           toast(EMPID_NULL.current, {
//             icon: "❗",
//             duration: 4500,
//           });
//           return;
//         }

//         // Redirect based on module and photo conditions
//         if (fetchedModule.length === 1 && fetchedModule.includes("CANTEEN")) {
//           navigate("/dashboard/home");
//           toast.success(LOGIN_SUCCESSFUL.current, { duration: 4000 });
//           return;
//         }
//         if (fetchedModule.includes("ATTENDANCE") && (!photo || photo.toString().length < 100)) {
//           toast.success(LOGIN_SUCCESSFUL.current, { duration: 4000 });
//           navigate("/onboarding/1");
//         } else {
//           toast.success(LOGIN_SUCCESSFUL.current, { duration: 4000 });
//           navigate("/dashboard/home");
//         }

//         // Fetch site locations
//         try {
//           const locationResponse = await getLocation(userID, empID, token);
//           localStorage.setItem("location", JSON.stringify(locationResponse.data));

//           // Fetch current office location
//           fetchLocation()
//             .then((locationData) => {
//               if (locationData) {
//                 localStorage.setItem("fetchedLoc", JSON.stringify(locationData));
//               } else {
//                 toast(PROBLEM_FETCHING_LOCATION.current, {
//                   icon: "❗",
//                   duration: 4500,
//                 });
//               }
//             })
//             .catch((error) => {
//               toast(error.message, { icon: "❗", duration: 4500 });
//               removeFetchedLoc(); // Ensure fetchedLoc is removed on error
//             });
//         } catch (error) {
//           toast(ERROR_SITE_LOCATIONS.current, { icon: "❗" });
//           removeFetchedLoc(); // Ensure fetchedLoc is removed on error
//         }
//       }
//     } catch (error) {
//       localStorage.clear();
//       toast(LOGIN_API_ERROR.current, { icon: "❗", duration: 4500 });
//       removeFetchedLoc(); // Ensure fetchedLoc is removed on login error
//     }
//   };

//   return (
//     <section className={classes.container}>
//       <div className={classes.LoginDiv}>
//         <div className={classes.ImageDiv}>
//           <img src={window.env.LOGO} alt="" width={"100"} />
//           <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
//             <h1>Login</h1>
//             <p>Please login to continue</p>
//           </div>
//         </div>
//         <InputField
//           type="text"
//           placeholder="Username"
//           name="Username"
//           onChange={(event) => setUserID(event.target.value)}
//           value={userID.toUpperCase()}
//         />
//         <InputField
//           type={isVisible ? "text" : "password"}
//           placeholder="Password"
//           name="Password"
//           style={{ position: "relative" }}
//           onChange={(event) => setPassword(event.target.value)}
//           value={password}
//         >
//           <img
//             src={Visibile}
//             alt="hidden Eye"
//             style={{ position: "absolute", padding: "20px", right: "0" }}
//             onClick={changeVisibilty}
//           />
//         </InputField>
//         <p onClick={() => (window.location.href = window.env.PWDRST_URL)}>Forgot Your Password?</p>
//         <p onClick={() => (window.location.href = window.env.CHECK_URL)}>Trouble Marking Attendance?</p>
//         <button onClick={handleLogin}>
//           Login
//           <img src={RightArrow} alt="" />
//         </button>
//       </div>
//     </section>
//   );
// };

// export default Login;









